import React, { useState, useEffect, useRef } from "react";

import { Button, Grid, InputBase, Popper, Grow, Paper, ClickAwayListener, Link, MenuList, TextField } from "@material-ui/core";

import Tooltip from '@material-ui/core/Tooltip';
import ClearIcon from '@material-ui/icons/Clear';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

import { data as gridCnfg } from './setupData';

import { SearchOutlined as SearchIcon } from '@material-ui/icons';

import Details from './../../assets/img/action/details.svg';
import MonthlyUsage from './../../assets/img/action/monthlyUsage.svg';
import Settings from './../../assets/img/action/settings.svg';
import ActionIcon from './../../assets/img/action/action.svg';
import ChangeName from './../../assets/img/action/changeName.svg';
import Reconnect from './../../assets/img/action/reconnect.svg';
import Disconnect from './../../assets/img/action/disconnect.svg';
import Suspend from './../../assets/img/action/suspend.svg';
import SimSwap from './../../assets/img/action/undo.svg';
import Usage from './../../assets/img/action/usage.svg';
import Forward from './../../assets/img/action/forward.svg';
import GiftIcon from './../../assets/img/action/gift.svg';
import Delete from './../../assets/img/icons/Delete.svg';
import Pen from './../../assets/img/action/pen.svg';
import DeleteNoSpace from './../../assets/img/icons/DeleteNoSpace.svg';
import RejectedIcon from "../../assets/img/icons/FaildIcon.svg";
import LoadingIcon from "./../../assets/img/icons/loaderIcon.gif";
import AddNotes from './../../assets/img/icons/addNotes.svg'
import DocumentSVG from "./../../assets/img/attachmentIcon.svg";
import ViewNotes from './../../assets/img/icons/eye.svg';
import PackageEmail from './../../assets/img/icons/packageEmail.svg';
import SimActivationIcon from './../../assets/img/icons/SimActivationIcon.svg';

import LogOff from './../../assets/img/icons/LogOff.svg';
import PlayPause from './../../assets/img/icons/playPause.svg';
import NoRecord from "./../NoRecord/NoRecord";
import AddIcon from "./../../assets/img/buttonIcons/add.svg";
import BucketUpdate from "./../../assets/img/shop/ordreCart.svg";
import AddCash from './../../assets/img/shop/addCash.svg';
import { EyeOutlined } from '@ant-design/icons';
import PrintIcon from './../../../src/images/icons/PrintIcon.png';
import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';

import PersonalIdentityChange from './../../assets/img/icons/PersonalIdentityChange.svg';
import RecievingPictureChange from './../../assets/img/icons/RecievingPictureChange.svg';

import ListAltIcon from '@material-ui/icons/ListAlt';
import ViewActiveLog from './../../assets/img/icons/activeLog.svg'
import { formatDate, formatDateTime, numberDisplay } from '../../../src/components/Common/Extensions';
import DeliveryIco from "./../../assets/img/icons/Menudelivery.svg";

import { Table, TableRow, Collapse, Empty, Dropdown, message, Menu, Typography, Tag } from 'antd';

import useStyles from "./styles";
import './style.css';
import 'antd/dist/antd.css';
import SimCardIcon from './../../assets/img/icons/sim_active.png';
import { SearchOutlined, Update } from "@material-ui/icons";
import UndoIcon from './../../assets/img/icons/undo.svg';

export default function SearchGrid({ onChange, selectedView, Icon, columns, getSelectedRows, isSelection, isSearchAble, onActionClick, onEditClick, isLetterofSupportAgencyDelete, onDeleteClick, onViewDetails, onRowClick, isUpdate, list, onChangeSearchValue, isGridLoaded, expandedRowRender, expandedRowKeys, onTableRowExpand, alreadySelectedRows, isTopPagination, callBackFilteredRecord, handlePageChange, totalRows, ...props }) {
    const classes = useStyles();
    const regex = /(<([^>]+)>)/ig;
    const [values, setValues] = useState({});
    const [value, setValue] = useState('');

    const [rowsData, setRowsData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    useEffect(() => {
        //if (props.filter !== undefined && props.filter != '') {
        //    handleSearchChange(props.filter);
        //} else {
        //    loadGridData(list);
        //}
        //if (!props.filter) {
        loadGridData(list);
        //}
        setSelectedRows(alreadySelectedRows);
    }, [isUpdate]);


    const onSelectChange = (selectedRowKeys) => {
        setSelectedRows(selectedRowKeys);
        if (!!getSelectedRows) {
            getSelectedRows(selectedRowKeys);
        }
    }

    const items = [
        { key: 'lineDetails', label: 'Line Details', icon: Details },
        { key: 'reconnect', label: 'Reconnect', icon: Reconnect },
        { key: 'restore', label: 'Restore', icon: Reconnect },
        { key: 'usage', label: 'Usage', icon: Usage },
        { key: 'monthlyUsage', label: 'Monthly Usage', icon: MonthlyUsage },
        { key: 'changePhoneNumber', label: 'Change Phone Number', icon: Settings },
        { key: 'changeLineName', label: 'Change Line Name', icon: ChangeName },
        { key: 'forwardNumber', label: 'Forward Number', icon: Forward },
        { key: 'suspendNumber', label: 'Suspend Number', icon: Suspend },
        { key: 'customerNotes', label: 'Add Notes', icon: AddNotes },
        { key: 'viewCustomerNotes', label: 'View Notes', icon: ViewNotes },
        { key: 'viewActivityLog', label: 'View Log', icon: ViewActiveLog },
        { key: 'simSwipe', label: 'Swap SIM', icon: SimSwap },
        { key: 'imeiCheck', label: 'IMEI Check', icon: Details },
        { key: 'disconnect', label: 'Disconnect', icon: Disconnect },
        { key: 'bucketUpdate', label: 'Bucket Update', icon: BucketUpdate },
        { key: 'addCash', label: 'Add Cash', icon: AddCash },
    ];
    const corporateUserItems = [
        { key: 'setupUsers', label: 'Setup Users', icon: AddIcon },
        { key: 'monthToDateReport', label: 'Month To Date Report', icon: MonthlyUsage },
        { key: 'updateRecord', label: 'Update Record', icon: ChangeName },
        { key: 'killSwitch', label: 'Kill Switch', icon: LogOff },
        { key: 'playPause', label: 'Deactivate', icon: PlayPause },
    ];

    const orderTrackingAction = [
        { key: 'printLabel', label: 'Print Label', icon: PrintIcon },
        { key: 'details', label: 'Details', icon: MonthlyUsage },
        { key: 'statusSummary', label: 'Summary', icon: ViewNotes },
        { key: 'updateRecord', label: 'Update', icon: ChangeName },
        { key: 'delete', label: 'Delete', icon: DeleteNoSpace },
    ];

    const donationGridAction = [
        { key: 'sendGift', label: 'Send A Gift', icon: GiftIcon },
        { key: 'printLabel', label: 'Print Label', icon: PrintIcon },
        { key: 'printReceipt', label: 'Print Receipt', icon: ViewNotes },
        { key: 'summary', label: 'Summary', icon: ChangeName },
    ];


    const sheilaTableAction = [
        { key: 'preview', label: 'Preview', icon: ViewNotes },
        { key: 'edit', label: 'Edit', icon: ChangeName },
        { key: 'delivery', label: 'Add Delivery', icon: DeliveryIco },
        { key: 'pickupEmail', label: 'Send Pickup Email', icon: PackageEmail },
        { key: 'askForReview', label: 'Ask For Review', icon: PackageEmail },
        { key: 'print', label: 'Print', icon: PrintIcon },
        /*{ key: 'activate', label: 'Activate SIM', icon: SimCardIcon },*/
        { key: 'editPersonalIdentity', label: 'Change Personal Identity', icon: PersonalIdentityChange },
        { key: 'editReceivingPicture', label: 'Change Receiving Picture', icon: RecievingPictureChange },
        { key: 'reject', label: 'Reject', icon: RejectedIcon },
        { key: 'undoRejection', label: 'Undo Reject', icon: UndoIcon },
        { key: 'delete', label: 'Delete', icon: DeleteNoSpace },

    ];

    const palmBeachTableAction = [
        { key: 'preview', label: 'Preview', icon: ViewNotes },
        { key: 'edit', label: 'Edit', icon: ChangeName },
        { key: 'delivery', label: 'Add Delivery', icon: DeliveryIco },
        { key: 'pickupEmail', label: 'Send Pickup Email', icon: PackageEmail },
        { key: 'askForReview', label: 'Ask For Review', icon: PackageEmail },
        { key: 'print', label: 'Print', icon: PrintIcon },
        { key: 'activationDetails', label: 'Activation Details', icon: SimActivationIcon },
        /*{ key: 'activate', label: 'Activate SIM', icon: SimCardIcon },*/
        { key: 'editPersonalIdentity', label: 'Change Personal Identity', icon: PersonalIdentityChange },
        { key: 'editReceivingPicture', label: 'Change Receiving Picture', icon: RecievingPictureChange },
        { key: 'reject', label: 'Reject', icon: RejectedIcon },
        { key: 'undoRejection', label: 'Undo Reject', icon: UndoIcon },
        { key: 'delete', label: 'Delete', icon: DeleteNoSpace },

    ];

    const floridaTableAction = [
        { key: 'preview', label: 'Preview', icon: ViewNotes },
        { key: 'edit', label: 'Edit', icon: ChangeName },
        { key: 'delivery', label: 'Add Delivery', icon: DeliveryIco },
        { key: 'pickupEmail', label: 'Send Pickup Email', icon: PackageEmail },
        { key: 'askForReview', label: 'Ask For Review', icon: PackageEmail },
        { key: 'print', label: 'Print', icon: PrintIcon },
        { key: 'activationDetails', label: 'Activation Details', icon: SimActivationIcon },
        { key: 'beneficiariesDetail', label: 'Beneficiaries Detail', icon: Details },
        { key: 'sendQRCode', label: 'Send QR Code', icon: SimActivationIcon },
        /*{ key: 'activate', label: 'Activate SIM', icon: SimCardIcon },*/
        { key: 'editPersonalIdentity', label: 'Change Personal Identity', icon: PersonalIdentityChange },
        { key: 'editReceivingPicture', label: 'Change Receiving Picture', icon: RecievingPictureChange },
        { key: 'reject', label: 'Reject', icon: RejectedIcon },
        { key: 'undoRejection', label: 'Undo Reject', icon: UndoIcon },
        { key: 'delete', label: 'Delete', icon: DeleteNoSpace },

    ];

    const RepRequestsTableAction = [
        { key: 'preview', label: 'Preview', icon: ViewNotes },
        // { key: 'delivery', label: 'Add Delivery', icon: DeliveryIco },
        // { key: 'pickupEmail', label: 'Send Pickup Email', icon: PackageEmail },
        { key: 'askForReview', label: 'Ask For Review', icon: PackageEmail },
        { key: 'print', label: 'Print', icon: PrintIcon },
        { key: 'activationDetails', label: 'Activation Details', icon: SimActivationIcon },
        /*{ key: 'activate', label: 'Activate SIM', icon: SimCardIcon },*/
        { key: 'editPersonalIdentity', label: 'Change Personal Identity', icon: PersonalIdentityChange },
        { key: 'editReceivingPicture', label: 'Change Receiving Picture', icon: RecievingPictureChange },
        // { key: 'reject', label: 'Reject', icon: RejectedIcon },
        { key: 'undoRejection', label: 'Undo Reject', icon: UndoIcon },
        //{ key: 'delete', label: 'Delete', icon: DeleteNoSpace },

    ];


    const christmasTableAction = [
        { key: 'approve', label: 'Approve' },
        { key: 'reject', label: 'Reject' }
    ];

    const simOrderActions = [
        { key: 'createShippingLabel', label: "Create Shipping Label", icon: "" },
        { key: 'activateSim', label: "Activate Sim", icon: "" },
        { key: 'refund', label: "Refund", icon: "" },
        { key: 'deleteRecord', label: "Delete Record", icon: "" },
    ];

    const portOrderAction = [
        { key: 'editPortNumber', label: "Edit", icon: "" },
        { key: 'recordDetail', label: "Record Details", icon: "" },
        { key: 'UpsTracking', label: "UPS Tracking", icon: "" },
        { key: 'refund', label: "refund", icon: "" },
        { key: 'deleteRecord', label: "Delete", icon: "" },
    ];

    const addressBook = [
        { key: 'addNotes', label: "Add Notes", icon: AddNotes },
        { key: 'viewNotes', label: "View Notes", icon: ViewNotes },
        { key: 'edit', label: "Edit", icon: ChangeName },
        { key: 'delete', label: "Delete", icon: DeleteNoSpace },
    ];

    const letterOfSupportActions = [
        { key: 'edit', label: "Edit", icon: ChangeName },
        { key: 'lOSReceived', label: "LOS Received", icon: DocumentSVG },
        { key: 'delete', label: "Delete", icon: DeleteNoSpace },
    ];

    const GrantHistoryAction = [
        { key: 'authorization', label: "Authorization" },
    ];

    const cashDisbursement = [
        { key: 'Details', label: 'View Details' },
        { key: 'Authorization', label: 'Authorization' },

    ]

    const donorAction = [

        { key: 'delete', label: "Delete", icon: DeleteNoSpace },
        { key: 'viewDetails', label: "View Details", icon: ViewNotes },
    ];

    const onClick = (key, item) => {
        if (onActionClick) {
            onActionClick(key, item);
        }
        // message.info(`Click on item ${item.label}`);
    };
    const accessPermissionEnum = {
        NOTVISIBLE: 0,
        NOTEDITABLE: 1,
        EDITABLE: 2
    };

    const loadGridData = (_filteredRecord) => {
        if (_filteredRecord) {
            setRowsData(
                _filteredRecord.map((item, i) => {
                    item.customerInformation = <div className={classes.customerInformation}>
                        <span>
                            <Typography component="h5">Full Name: </Typography>
                            <Typography component="p">{item.fullName}</Typography>
                        </span>
                        <span>
                            <Typography component="h5">Phone #:</Typography>
                            <Typography component="p">{item.phone}</Typography>
                        </span>
                        <span>
                            <Typography component="h5">Email :</Typography>
                            <Typography component="p">{item.email}</Typography>
                        </span>
                        <span>
                            <Typography component="h5">Address :</Typography>
                            <Typography component="p">{item.address}</Typography>
                        </span>
                    </div>
                    item.orderInformation = <div className={classes.orderInformation}>
                        <span>
                            <Typography component="h5">Order Date: </Typography>
                            <Typography component="p">{item.orderDate}</Typography>
                        </span>
                        <span>
                            <Typography component="h5">Figgers Account:</Typography>
                            <Typography component="p">{item.figgersAccount}</Typography>
                        </span>
                        <span>
                            <Typography component="h5">Billing Cycle:</Typography>
                            <Typography component="p">{item.billingCycle}</Typography>
                        </span>
                        <span>
                            <Typography component="h5">Plan:</Typography>
                            <Typography component="p">{item.plan}</Typography>
                        </span>
                    </div>
                    if (item.firstName) {
                        item.fullName = (item.firstName) + (item.lastName ? ' ' + item.lastName : '');
                    }


                    item.confirmationCode = <>
                        <div className={item.createdBy > 0 ? 'manuallyAdded' : ''}

                        >
                            <div style={{ display: 'flex', gap: '6px' }}>
                                <div className={classes.linkPreview} style={{ justifyContent: 'left' }}>
                                    <Tooltip title="Preview" style={{ justifyContent: 'center' }}>
                                        <EyeOutlined onClick={() => { onActionClick('preview', item) }} />
                                    </Tooltip>
                                </div>
                                <div className={classes.linkPreview} style={{ justifyContent: 'left' }}>
                                    <Tooltip title="Edit" style={{ justifyContent: 'center' }}>
                                        <img src={Pen} alt='Edit' onClick={() => { onActionClick('edit', item) }} className={item.status === "Approved" ? "disabledEvent" : ""} />
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    </>

                    item.pressReleaseConfirmationCode = <>
                        <div className={item.createdBy > 0 ? 'manuallyAdded' : ''}

                        >
                            <div style={{ display: 'flex', gap: '6px' }}>
                                <div className={classes.linkPreview} style={{ justifyContent: 'left' }}>
                                    <Tooltip title="Preview" style={{ justifyContent: 'center' }}>
                                        <EyeOutlined onClick={() => { onActionClick('preview', item) }} />
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    </>

                    item.letterOfSupportView = <>
                        <div style={{ display: 'flex', gap: '6px' }}>
                            <div className={classes.linkPreview} style={{ justifyContent: 'left' }}>
                                <Tooltip title="Preview" style={{ justifyContent: 'center' }}>
                                    <EyeOutlined onClick={() => { onActionClick('preview', item) }} />
                                </Tooltip>
                            </div>
                        </div>
                    </>


                    item.portOrderAction = <div className="textCenter">
                        <Dropdown overlay={<Menu>
                            {
                                portOrderAction.map((menuItem, index) => {

                                    if (
                                        (item.orderStatus == 'Pending' && menuItem.key == 'activateSim')
                                        || (item.orderStatus == 'Shipped' && (menuItem.key == 'activateSim' || menuItem.key == 'createShippingLabel'))
                                        || (item.orderStatus == 'Delivered' && menuItem.key == 'createShippingLabel')
                                        || (item.orderStatus == 'Activated' && (menuItem.key == 'activateSim' || menuItem.key == 'createShippingLabel'))
                                        || (item.orderStatus == 'Void' && (menuItem.key == 'activateSim' || menuItem.key == 'createShippingLabel'))
                                        || (item.orderStatus == 'Refunded' && (menuItem.key == 'activateSim' || menuItem.key == 'createShippingLabel' || menuItem.key == 'refund'))

                                    )
                                        return ''
                                    else
                                        return <Menu.Item
                                            onClick={() => onClick(menuItem.key, item)}
                                            key={menuItem.key}
                                            className={classes.DropdownItems}
                                        > <img src={menuItem.icon} /> {menuItem.label}
                                        </Menu.Item>
                                })
                            }
                        </Menu>} trigger={["click"]}
                            className={classes.actionDropDown}>
                            <Button className={classes.actionBtn} startIcon={<img src={ActionIcon} alt="action" />}>
                                Actions <ArrowDropDownIcon />
                            </Button>
                        </Dropdown>
                    </div>

                    item.addressAction = <div className="textCenter">
                        <Dropdown overlay={<Menu>
                            {
                                addressBook.map((menuItem, index) => {

                                    return <Menu.Item
                                        onClick={() => onClick(menuItem.key, item)}
                                        key={menuItem.key}
                                        className={classes.DropdownItems}
                                    > <img src={menuItem.icon} /> {menuItem.label}
                                    </Menu.Item>
                                })
                            }
                        </Menu>} trigger={["click"]}
                            className={classes.actionDropDown}>
                            <Button className={classes.actionBtn} startIcon={<img src={ActionIcon} alt="action" />}>
                                Actions <ArrowDropDownIcon />
                            </Button>
                        </Dropdown>
                    </div>

                    item.orderTrackingAction = <div className="textCenter">
                        <Dropdown overlay={<Menu>
                            {
                                orderTrackingAction.map((menuItem, index) => {
                                    if ((menuItem.key == 'delete' || menuItem.key == 'updateRecord') && (item.isDeleted || item.status == "MV")) {
                                        return '';
                                    } else if (menuItem.key == 'details' && !item.orderId) {
                                        return '';
                                    }
                                    else {
                                        return <Menu.Item
                                            onClick={() => onClick(menuItem.key, item)}
                                            key={menuItem.key}
                                            className={classes.DropdownItems}
                                        > <img src={menuItem.icon} /> {menuItem.label}
                                        </Menu.Item>
                                    }

                                })
                            }
                        </Menu>} trigger={["click"]}
                            className={classes.actionDropDown}>
                            <Button className={classes.actionBtn} startIcon={<img src={ActionIcon} alt="action" />}>
                                Actions <ArrowDropDownIcon />
                            </Button>
                        </Dropdown>
                    </div>

                    item.donationGridAction = <div className="textCenter">
                        <Dropdown overlay={<Menu>
                            {
                                //DropdownItemsDisabled
                                donationGridAction.map((menuItem, index) => {
                                    if ((menuItem.key == 'sendGift' && (item.transactionStatus == 'Error' || item.trackingNumber))
                                        || ((menuItem.key == 'summary' || menuItem.key == 'printLabel') && !item.trackingNumber)
                                    ) {
                                        return <Menu.Item
                                            key={menuItem.key}
                                            className={classes.DropdownItemsDisabled}
                                        > <img src={menuItem.icon} /> {menuItem.label}
                                        </Menu.Item>
                                    }
                                    else {
                                        return <Menu.Item
                                            onClick={() => onClick(menuItem.key, item)}
                                            key={menuItem.key}
                                            className={classes.DropdownItems}
                                        > <img src={menuItem.icon} /> {menuItem.label}
                                        </Menu.Item>
                                    }

                                })
                            }
                        </Menu>} trigger={["click"]}
                            className={classes.actionDropDown}>
                            <Button className={classes.actionBtn} startIcon={<img src={ActionIcon} alt="action" />}>
                                Actions <ArrowDropDownIcon />
                            </Button>
                        </Dropdown>
                    </div>
                    //     item.GrantHistoryAction = <div className="textCenter">
                    //     <Dropdown overlay={<Menu>
                    //         {
                    //             //DropdownItemsDisabled
                    //             GrantHistoryAction.map((menuItem, index) => {

                    //                     return <Menu.Item
                    //                         onClick={() => onClick(menuItem.key, item)}
                    //                         key={menuItem.key}
                    //                         className={classes.DropdownItems}
                    //                     > <img src={menuItem.icon} /> {menuItem.label}
                    //                     </Menu.Item>


                    //             })
                    //         }
                    //     </Menu>} trigger={["click"]}
                    //         className={classes.actionDropDown}>
                    //         <Button className={classes.actionBtn} startIcon={<img src={ActionIcon} alt="action" />}>
                    //             Actions <ArrowDropDownIcon />
                    //         </Button>
                    //     </Dropdown>
                    // </div>

                    item.GrantHistoryAction = (
                        <div className={`${classes.HistoryBtnsAlign} textCenter`}>
                            {GrantHistoryAction.map((item) => (
                                <Button className={classes.rejectClassNew}
                                    // startIcon={item.icon ? <img src={item.icon} alt={item.key} /> : null}
                                    style={{}}>
                                    {item.label}
                                </Button>
                            ))}
                        </div>
                    );

                    item.cashDisbursement = (
                        <div className={`${classes.HistoryBtnsAlign} textCenter`}>
                            {cashDisbursement.map((item) => (
                                <Button
                                    onClick={() => onClick(item.key, item)}
                                    className={`
                                    
                                    ${item.key === 'Details' ? classes.approveClassNew : ''} ${item.key === 'Authorization' ? classes.rejectClassNew : ''}`}
                                    // startIcon={item.icon ? <img src={item.icon} alt={item.key} /> : null}
                                    style={{}}
                                >
                                    {item.label}
                                </Button>
                            ))}
                        </div>
                    );


                    item.donorBtns = <div className="textCenter">
                        <Dropdown overlay={<Menu>
                            {
                                donorAction.map((menuItem, index) => {

                                    return <Menu.Item
                                        onClick={() => onClick(menuItem.key, item)}
                                        key={menuItem.key}
                                        className={classes.DropdownItems}
                                    > <img src={menuItem.icon} /> {menuItem.label}
                                    </Menu.Item>
                                })
                            }
                        </Menu>} trigger={["click"]}
                            className={classes.actionDropDown}>
                            <Button className={classes.actionBtn} startIcon={<img src={ActionIcon} alt="action" />}>
                                Actions <ArrowDropDownIcon />
                            </Button>
                        </Dropdown>
                    </div>

                    item.customerNotesAction = <>

                        <div className={classes.linkContainer} style={{ justifyContent: 'center' }}>
                            {onDeleteClick ?
                                <Tooltip title="Delete">
                                    <img src={Delete} onClick={() => { onDeleteClick(item) }} />
                                </Tooltip> :
                                ''}
                        </div>

                    </>
                    item.inventoryAction = <>

                        <div className={classes.linkContainer} style={{ justifyContent: 'center' }}>
                            {onDeleteClick ?
                                <Tooltip title="Delete">
                                    <img src={Delete} onClick={() => { onDeleteClick(item) }} />
                                </Tooltip> :
                                ''}

                            {onEditClick ?
                                <Tooltip title="Edit">
                                    <img src={Pen} onClick={() => { onEditClick(item) }} />
                                </Tooltip> :
                                ''}
                        </div>
                    </>
                    item.sheilaActions = <>
                        <div className="textCenter">
                            <Dropdown overlay={<Menu>
                                {
                                    sheilaTableAction.map((menuItem, index) => {
                                        if (item.status == 'Delivered' &&
                                            ((menuItem.key == 'activate' && item.assignedPhoneNumber)
                                                || menuItem.key == 'reject' || menuItem.key == 'delete'
                                                || menuItem.key == 'edit' || menuItem.key == 'rejected'
                                                || menuItem.key == 'delivery' || menuItem.key == 'pickupEmail'
                                                || menuItem.key == 'undoRejection')) {
                                            return '';
                                        }
                                        else if ((item.status == 'Pending') &&
                                            (menuItem.key == 'activate' || menuItem.key == 'editReceivingPicture'
                                                || menuItem.key == 'editPersonalIdentity' || menuItem.key == 'askForReview'
                                                || menuItem.key == 'undoRejection')) {
                                            return '';
                                        }
                                        else if ((item.status == 'Enrolled') &&
                                            (menuItem.key == 'activate' || menuItem.key == 'reject' || menuItem.key == 'editReceivingPicture'
                                                || menuItem.key == 'editPersonalIdentity' || menuItem.key == 'askForReview'
                                                || menuItem.key == 'undoRejection')) {
                                            return '';
                                        }
                                        else if ((item.status == 'Rejected') &&
                                            (menuItem.key == 'edit'
                                                || menuItem.key == 'editReceivingPicture'
                                                || menuItem.key == 'editPersonalIdentity'
                                                || menuItem.key == 'delivery'
                                                || menuItem.key == 'pickupEmail'
                                                || menuItem.key == 'reject'
                                                || menuItem.key == 'print'
                                                || menuItem.key == 'activate'
                                                || menuItem.key == 'askForReview'
                                            )) {
                                            return '';
                                        }
                                        else {
                                            return <Menu.Item
                                                onClick={() => onClick(menuItem.key, item)}
                                                key={menuItem.key}
                                                className={classes.DropdownItems}
                                            > <img src={menuItem.icon} /> {menuItem.label}
                                            </Menu.Item>
                                        }

                                    })
                                }
                            </Menu>} trigger={["click"]}
                                className={classes.actionDropDown}>
                                <Button className={classes.actionBtn} startIcon={<img src={ActionIcon} alt="action" />}>
                                    Actions <ArrowDropDownIcon />
                                </Button>
                            </Dropdown>
                        </div>
                    </>


                    item.floridaAction = <>
                        <div className="textCenter">
                            <Dropdown overlay={<Menu>
                                {
                                    floridaTableAction.map((menuItem, index) => {
                                        if (item.status == 'Delivered' &&
                                            ((menuItem.key == 'activate' && item.assignedPhoneNumber)
                                                || menuItem.key == 'reject' || menuItem.key == 'delete'
                                                || menuItem.key == 'edit' || menuItem.key == 'rejected'
                                                || menuItem.key == 'delivery' || menuItem.key == 'pickupEmail'
                                                || menuItem.key == 'undoRejection')) {
                                            return '';
                                        }
                                        else if ((item.status == 'Pending') &&
                                            (menuItem.key == 'activate' || menuItem.key == 'editReceivingPicture'
                                                || menuItem.key == 'editPersonalIdentity' || menuItem.key == 'askForReview'
                                                || menuItem.key == 'undoRejection' || menuItem.key == 'activationDetails')) {
                                            return '';
                                        }
                                        else if ((item.status == 'Enrolled') &&
                                            (menuItem.key == 'activate' || menuItem.key == 'reject' || menuItem.key == 'editReceivingPicture'
                                                || menuItem.key == 'editPersonalIdentity' || menuItem.key == 'askForReview'
                                                || menuItem.key == 'undoRejection' || menuItem.key == 'activationDetails')) {
                                            return '';
                                        }
                                        else if ((item.status == 'Rejected') &&
                                            (menuItem.key == 'edit'
                                                || menuItem.key == 'editReceivingPicture'
                                                || menuItem.key == 'editPersonalIdentity'
                                                || menuItem.key == 'delivery'
                                                || menuItem.key == 'pickupEmail'
                                                || menuItem.key == 'reject'
                                                || menuItem.key == 'print'
                                                || menuItem.key == 'activate'
                                                || menuItem.key == 'askForReview'
                                                || menuItem.key == 'activationDetails'
                                            )) {
                                            return '';
                                        }
                                        else if (
                                            menuItem.key === 'beneficiariesDetail' &&
                                            (
                                                item.program !== 'FloridaConnect' ||
                                                !item.noOfBeneficiaries ||
                                                item.noOfBeneficiaries <= 0 ||
                                                !item.programBeneficiaries ||
                                                item.programBeneficiaries.length === 0 ||
                                                item.status != 'Delivered'
                                            )
                                        ) {
                                            return '';
                                        }
                                        else if (
                                            menuItem.key === 'sendQRCode' &&
                                            (
                                                item.program !== 'FloridaConnect' ||
                                                item.noOfBeneficiaries > 0 ||
                                                item.status != 'Delivered'
                                            )
                                        ) {
                                            return '';
                                        }
                                        else {
                                            return <Menu.Item
                                                onClick={() => onClick(menuItem.key, item)}
                                                key={menuItem.key}
                                                className={classes.DropdownItems}
                                            > <img src={menuItem.icon} /> {menuItem.label}
                                            </Menu.Item>
                                        }

                                    })
                                }
                            </Menu>} trigger={["click"]}
                                className={classes.actionDropDown}>
                                <Button className={classes.actionBtn} startIcon={<img src={ActionIcon} alt="action" />}>
                                    Actions <ArrowDropDownIcon />
                                </Button>
                            </Dropdown>
                        </div>
                    </>

                    item.palmBeachActions = <>
                        <div className="textCenter">
                            <Dropdown overlay={<Menu>
                                {
                                    palmBeachTableAction.map((menuItem, index) => {
                                        if (item.status == 'Delivered' &&
                                            ((menuItem.key == 'activate' && item.assignedPhoneNumber)
                                                || menuItem.key == 'reject' || menuItem.key == 'delete'
                                                || menuItem.key == 'edit' || menuItem.key == 'rejected'
                                                || menuItem.key == 'delivery' || menuItem.key == 'pickupEmail'
                                                || menuItem.key == 'undoRejection')) {
                                            return '';
                                        }
                                        else if ((item.status == 'Pending') &&
                                            (menuItem.key == 'activate' || menuItem.key == 'editReceivingPicture'
                                                || menuItem.key == 'editPersonalIdentity' || menuItem.key == 'askForReview'
                                                || menuItem.key == 'undoRejection' || menuItem.key == 'activationDetails')) {
                                            return '';
                                        }
                                        else if ((item.status == 'Enrolled') &&
                                            (menuItem.key == 'activate' || menuItem.key == 'reject' || menuItem.key == 'editReceivingPicture'
                                                || menuItem.key == 'editPersonalIdentity' || menuItem.key == 'askForReview'
                                                || menuItem.key == 'undoRejection' || menuItem.key == 'activationDetails')) {
                                            return '';
                                        }
                                        else if ((item.status == 'Rejected') &&
                                            (menuItem.key == 'edit'
                                                || menuItem.key == 'editReceivingPicture'
                                                || menuItem.key == 'editPersonalIdentity'
                                                || menuItem.key == 'delivery'
                                                || menuItem.key == 'pickupEmail'
                                                || menuItem.key == 'reject'
                                                || menuItem.key == 'print'
                                                || menuItem.key == 'activate'
                                                || menuItem.key == 'askForReview'
                                                || menuItem.key == 'activationDetails'
                                            )) {
                                            return '';
                                        }
                                        else {
                                            return <Menu.Item
                                                onClick={() => onClick(menuItem.key, item)}
                                                key={menuItem.key}
                                                className={classes.DropdownItems}
                                            > <img src={menuItem.icon} /> {menuItem.label}
                                            </Menu.Item>
                                        }

                                    })
                                }
                            </Menu>} trigger={["click"]}
                                className={classes.actionDropDown}>
                                <Button className={classes.actionBtn} startIcon={<img src={ActionIcon} alt="action" />}>
                                    Actions <ArrowDropDownIcon />
                                </Button>
                            </Dropdown>
                        </div>
                    </>

                    item.RepRequestsAction = <>
                        <div className="textCenter">
                            <Dropdown overlay={<Menu>
                                {
                                    RepRequestsTableAction.map((menuItem, index) => {
                                        if (item.status == 'Delivered' &&
                                            ((menuItem.key == 'activate' && item.assignedPhoneNumber)
                                                || menuItem.key == 'reject' || menuItem.key == 'delete'
                                                || menuItem.key == 'edit' || menuItem.key == 'rejected'
                                                || menuItem.key == 'delivery' || menuItem.key == 'pickupEmail'
                                                || menuItem.key == 'undoRejection')) {
                                            return '';
                                        }
                                        else if ((item.status == 'Pending') &&
                                            (menuItem.key == 'activate' || menuItem.key == 'editReceivingPicture'
                                                || menuItem.key == 'editPersonalIdentity' || menuItem.key == 'askForReview'
                                                || menuItem.key == 'undoRejection' || menuItem.key == 'activationDetails')) {
                                            return '';
                                        }
                                        else if ((item.status == 'Enrolled') &&
                                            (menuItem.key == 'activate' || menuItem.key == 'reject' || menuItem.key == 'editReceivingPicture'
                                                || menuItem.key == 'editPersonalIdentity' || menuItem.key == 'askForReview'
                                                || menuItem.key == 'undoRejection' || menuItem.key == 'activationDetails')) {
                                            return '';
                                        }
                                        else if ((item.status == 'Rejected') &&
                                            (menuItem.key == 'edit'
                                                || menuItem.key == 'editReceivingPicture'
                                                || menuItem.key == 'editPersonalIdentity'
                                                || menuItem.key == 'delivery'
                                                || menuItem.key == 'pickupEmail'
                                                || menuItem.key == 'reject'
                                                || menuItem.key == 'print'
                                                || menuItem.key == 'activate'
                                                || menuItem.key == 'askForReview'
                                                || menuItem.key == 'activationDetails'
                                            )) {
                                            return '';
                                        }
                                        else {
                                            return <Menu.Item
                                                onClick={() => onClick(menuItem.key, item)}
                                                key={menuItem.key}
                                                className={classes.DropdownItems}
                                            > <img src={menuItem.icon} /> {menuItem.label}
                                            </Menu.Item>
                                        }

                                    })
                                }
                            </Menu>} trigger={["click"]}
                                className={classes.actionDropDown}>
                                <Button className={classes.actionBtn} startIcon={<img src={ActionIcon} alt="action" />}>
                                    Actions <ArrowDropDownIcon />
                                </Button>
                            </Dropdown>
                        </div>
                    </>



                    item.christmasActions = <div className={classes.christmasActions}>
                        <Button className={classes.approveClass} onClick={() => onClick("Approved", item)} disabled={item.status == 'Approved' ? true : false}>
                            Approve
                        </Button>

                        <Button className={classes.rejectClass} onClick={() => onClick("Rejected", item)} disabled={item.status == 'Rejected' ? true : false}>
                            Reject
                        </Button>

                    </div>

                    item.GranteeActions = <div className={classes.christmasActions}>
                        <Button className={classes.approveClassNew} onClick={() => onClick("Edit", item)} disabled={item.status == 'Approved' ? true : false}>
                            Edit
                        </Button>

                        <Button className={classes.rejectClassNew} onClick={() => onClick("Authorization", item)} disabled={item.status == 'Rejected' ? true : false}>
                            Authorization
                        </Button>
                    </div>
                    item.commonAction = <>
                        <div className={classes.commonAction}>


                            {onViewDetails ?
                                <Tooltip title="View">
                                    <img src={ViewNotes} onClick={() => { onViewDetails(item) }} />
                                </Tooltip> :
                                ''}


                            {onDeleteClick ?
                                <Tooltip title="Delete">
                                    <img src={Delete} onClick={() => { onDeleteClick(item) }} />
                                </Tooltip> :
                                ''}

                            {onEditClick ?
                                <Tooltip title="Edit">
                                    <img src={Pen} width="20px" onClick={() => { onEditClick(item) }} />
                                </Tooltip> :
                                ''}

                            {isLetterofSupportAgencyDelete ?
                                <Tooltip title="Delete">
                                    <img src={Delete} onClick={() => { isLetterofSupportAgencyDelete(item) }} />
                                </Tooltip> :
                                ''}
                        </div>

                    </>

                    item.openDocument = <>
                        <Tooltip title={item.docName}>
                            <a href={'.' + item.docPath} target="_blank">{item.docName}</a>
                            {/*<Typography component="p" onClick={() => { onActionClick('openDocument', item) }}>{item.docName}</Typography>*/}
                        </Tooltip>
                    </>

                    item.deleteAction = <>
                        <div className={classes.commonAction}>

                            {onDeleteClick ?
                                <Tooltip title="Delete">
                                    <img src={Delete} onClick={() => { onDeleteClick(item) }} />
                                </Tooltip> :
                                ''}
                        </div>

                    </>

                    item.customNoteHTML = <>
                        <Tooltip title={<p dangerouslySetInnerHTML={{
                            __html: item.customNote,
                        }}></p>}>
                            <p className={classes.truncate} dangerouslySetInnerHTML={{
                                __html: item.customNote,
                            }}></p>
                        </Tooltip>
                    </>
                    item.noteHTML = <>
                        <Tooltip title={<p dangerouslySetInnerHTML={{
                            __html: item.note,
                        }}></p>}>
                            <p dangerouslySetInnerHTML={{
                                __html: item.note,
                            }}></p>
                        </Tooltip>
                    </>
                    item.notesHTML = <>
                        <Tooltip title={<p dangerouslySetInnerHTML={{
                            __html: item.notes,
                        }}></p>}>
                            <p dangerouslySetInnerHTML={{
                                __html: item.notes ? item.notes.length > 200 ? item.notes.substring(0, 200) + '...' : item.notes : '',
                            }}></p>
                        </Tooltip>
                    </>
                    item.donationRequestAction = <> {
                        onEditClick ?
                            <Tooltip title="Edit">
                                <img src={Pen} onClick={() => { onEditClick(item) }} />
                            </Tooltip> :
                            ''
                    }</>


                    item.donationAction = <>

                        <div className={classes.linkContainer} style={{ justifyContent: 'center' }}>
                            <Tooltip title="Print">
                                <img src={PrintIcon} onClick={() => { onActionClick('Print', item) }} />
                            </Tooltip>

                        </div>
                    </>

                    item.statusCol = <div className="statuses"><span className={
                        item.status === "Active" ? 'activeStatus' :
                            item.status === "Inactive" ? 'inActiveStatus' :
                                item.status === "Suspended" ? 'SuspendedStatus' :
                                    item.status === "Disconnected" ? 'disconnectStatus' :
                                        item.status === "Hotlined" ? 'hotlineStatus' : ''


                    }> {item.status}</span >
                    </div>
                    { item.formattedAmount = columns == 'PaymentHistory' ? numberDisplay(item.amount, 2, 2, 0) : '' }

                    item.pressReleaseStatus = <>
                        {(item.status === 'Publishing' || item.status === 'Published') ?
                            item.status :
                            <div className={classes.linkContainer} style={{ justifyContent: 'center' }}>
                                <Tooltip title="Re-Schedule">
                                    <img src={PrintIcon} onClick={() => { onActionClick('Reschedule', item) }} />
                                </Tooltip>

                            </div>
                        }
                    </>

                    item.pressReleaseAction = <>
                        <div className={classes.commonAction}>

                            {/*{item.status === 'Scheduled' ?*/}
                            {/*    <Tooltip title="Publish Now">*/}
                            {/*        <img src={ViewNotes} onClick={() => { onViewDetails(item) }} />*/}
                            {/*    </Tooltip> :*/}
                            {/*    ''}*/}
                            {onDeleteClick ?
                                <Tooltip title="Delete">
                                    <img src={Delete} onClick={() => { onDeleteClick(item) }} />
                                </Tooltip> :
                                ''}

                        </div>

                    </>

                    item.letterOfSupportAction = <div className="textCenter">
                        <Dropdown overlay={<Menu>
                            {
                                letterOfSupportActions.map((menuItem, index) => {
                                    if (item.status != 'Draft' && menuItem.key == 'edit') {
                                        return '';
                                    }
                                    else {
                                        return <Menu.Item
                                            onClick={() => onClick(menuItem.key, item)}
                                            key={menuItem.key}
                                            className={classes.DropdownItems}
                                        > <img src={menuItem.icon} /> {menuItem.label}
                                        </Menu.Item>
                                    }

                                })
                            }
                        </Menu>} trigger={["click"]}
                            className={classes.actionDropDown}>
                            <Button className={classes.actionBtn} startIcon={<img src={ActionIcon} alt="action" />}>
                                Actions <ArrowDropDownIcon />
                            </Button>
                        </Dropdown>
                    </div>
                    item.healthCareTabletConfirmation =
                        //item.isRejectionUpdated ?
                        <>
                            {item.isRejectionUpdated ? <div className={'undoRejection'}></div> : ''}

                            < Tooltip title={item.isPickupEmailSent ? (item.isPickupDatePassed ? 'Pickup Date Passed' : 'Pickup Email Sent') : ''}>
                                <div className={item.isPickupEmailSent ? (item.isPickupDatePassed ? 'pickUpDatePassed' : 'pickUpEmailSent') : ''}></div>
                            </Tooltip >
                        </>
                    item.rolesAction = <>
                        <div className={classes.commonAction}>

                            {onDeleteClick &&
                                (item.accesPermission === accessPermissionEnum.EDITABLE ? (
                                    <Tooltip title="Delete">
                                        <img src={Delete} onClick={() => onDeleteClick(item)} />
                                    </Tooltip>
                                ) : (
                                    <img src={Delete} style={{ opacity: '50%', cursor: 'auto' }} />
                                ))}

                            {onEditClick ?
                                <Tooltip title="Edit">
                                    <img src={Pen} width="20px" onClick={() => { onEditClick(item) }} />
                                </Tooltip> :
                                ''}

                        </div>

                    </>
                    return { ...item }
                }
                ));
        }

    }

    const handleSearchChange = (currValue) => {


        const trimmedValue = currValue.trim()
        let filteredData = [];

        if (trimmedValue && trimmedValue != undefined && trimmedValue != null && trimmedValue != "") {

            if (onChangeSearchValue != undefined) {
                onChangeSearchValue(trimmedValue)
            }

            filteredData = [...list];
            filteredData = filteredData.filter(entry => {
                var hasValue = false;
                for (var prop in entry) {
                    if (Object.prototype.hasOwnProperty.call(entry, prop)) {
                        hasValue = entry[prop]?.toString().toLowerCase().includes(trimmedValue.toLowerCase());
                        if (hasValue)
                            break;
                    }
                }
                return hasValue;
            }
            );
            if (isGridLoaded) {
                setRowsData(filteredData);
            } else {
                loadGridData(filteredData);
            }
        } else {
            const filteredData = [...list];
            if (isGridLoaded) {
                setRowsData(filteredData);
            } else {
                loadGridData(filteredData);
            }
        }
        if (callBackFilteredRecord) {
            callBackFilteredRecord(filteredData)
        }

        isGridLoaded = true;
    }
    const handleClearInput = (name) => {
        setValue('');
        handleSearchChange('');
    };
    const handleSearch = (e) => {
        if (e.charCode == 13) {
            const currValue = e.target.value;
            if (currValue.trim().length > 0 || currValue == '') {
                setValue(currValue);
                handleSearchChange(currValue);
            }
        }
    }
    // Define pagination configuration
    // Define pagination configuration
    const [totalRecords, setTotalRecords] = useState(totalRows);
    const [currentPage, setCurrentPage] = useState(1);
    const handlePaginationChange = (page, pageSize) => {
        debugger;
        setCurrentPage(page);
        if (handlePageChange)
            handlePageChange(page, pageSize);
    }
    const paginationConfig = {
        position: [isTopPagination ? 'topRight' : '', 'bottomRight'],
        defaultPageSize: 10, showSizeChanger: true, pageSizeOptions: [10, 20, 30, 50],
        /*onChange: handlePaginationChange,*/ total: totalRows, current: currentPage
    };
    const [isSearch, setIsSearch] = useState(false);
    const hideIsSearch = () => {
        setValue('');
        setIsSearch(false);
    }
    const showIsSearch = () => {
        setIsSearch(true);
    }
    const handleTableChange = (pagination, filters, sorter) => {
        debugger;
        setCurrentPage(pagination.current);
        if (handlePageChange)
            handlePageChange(pagination.current, pagination.pageSize, false, sorter.field, sorter.order);
    }
    return (
        <>
            {isSearchAble ?
                <Grid container item direction="row" xs={12} sm={12} md={12} lg={12} xl={12} style={{ margin: '5px 0px' }}>
                    <Grid container item direction="row" xs={3} sm={3} md={3} lg={3} xl={3} style={{ marginLeft: 'auto' }}>
                        {/*<InputBase*/}
                        {/*    value={value}*/}
                        {/*    placeholder="Search"*/}
                        {/*    className="grid-search-input"*/}
                        {/*    startAdornment={<SearchIcon />}*/}
                        {/*    endAdornment={value ? <ClearIcon style={{ cursor: 'pointer' }} onClick={() => { handleClearInput('search') }} /> : ''}*/}
                        {/*    onKeyPress={handleSearch}*/}
                        {/*/>*/}
                        <TextField
                            size="small"
                            id="value"
                            name="accountNumber"
                            placeholder="Search by Account#, Name, Email"
                            value={value}
                            InputProps={{
                                endAdornment:
                                    !isSearch ?
                                        <SearchOutlined onClick={showIsSearch} /> :
                                        <ClearIcon onClick={hideIsSearch} />

                            }}
                            variant="outlined"
                            type="text"
                            //onChange={handleChange}
                            onKeyPress={handleSearch}
                            className={isSearch ? classes.SearchFieldOpen : classes.SearchField}

                        />

                    </Grid>
                </Grid>
                : ""}


            <div className="custom-grid">
                <Table
                    // loading={true}
                    rowKey={(record) => {
                        // Get the first property of the record object and use it as the row key
                        const keys = Object.keys(record);
                        return record[keys[0]];
                    }}
                    onRow={onRowClick ?
                        (record, rowIndex) => {
                            return {
                                onClick: (e) => onRowClick(record),
                                Style: 'cursor: pointer'
                            };
                        }
                        : () => { }}
                    locale={{
                        emptyText: (
                            <Empty
                                image={isLoading && LoadingIcon}
                                description={isLoading ? "Loading..." : <> <NoRecord Icon={Icon} message={props.noRecordMsg}></NoRecord> </>}
                                imageStyle={{ height: 30, display: !isLoading ? "none" : "" }}
                            />
                        )
                    }}
                    checkStrictly={true}
                    rowClassName={(record, index) => "claimRow"}
                    scroll={true}
                    pagination={paginationConfig}
                    dataSource={rowsData}
                    columns={gridCnfg[columns]}
                    size="small"
                    expandable={{
                        expandedRowRender: expandedRowRender,

                    }}
                    expandedRowKeys={expandedRowKeys}
                    onExpand={onTableRowExpand}
                    rowSelection={isSelection ? { selectedRowKeys: selectedRows, onChange: onSelectChange } : null}
                    onChange={handleTableChange}
                >

                </Table>
            </div>
        </>
    );
}